import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCEPREDICATE,
  DELETE_PERFORMANCEPREDICATE,
  UPDATE_PERFORMANCEPREDICATE,
  ADD_NEW_PERFORMANCEPREDICATE,
} from "./actionType";

import {
  getPerformancePredicateSuccess,
  getPerformancePredicateFail,
  deletePerformancePredicateSuccess,
  deletePerformancePredicateFail,
  updatePerformancePredicateSuccess,
  updatePerformancePredicateFail,
  addPerformancePredicateSuccess,
  addPerformancePredicateFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformancePredicateApi,
  getPerformancePredicateApi,
  updatePerformancePredicateApi,
  deletePerformancePredicateApi,
  addNewPerformancePredicateApi
} from "../../helpers/backend_helper";

function* getPerformancePredicate({ payload: performancePredicate }) {
  try {
    const response = yield call(getPerformancePredicateApi, performancePredicate);
    yield put(getPerformancePredicateSuccess(GET_PERFORMANCEPREDICATE, response.data));
  } catch (error) {
    yield put(getPerformancePredicateFail(GET_PERFORMANCEPREDICATE, error));
  }
}

function* onUpdatePerformancePredicate({ payload: performancePredicate }) {
  try {
    if (performancePredicate.setApprove) {
      const response = yield call(approvePerformancePredicateApi, performancePredicate);
      yield put(updatePerformancePredicateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformancePredicateApi, performancePredicate);
      yield put(updatePerformancePredicateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformancePredicateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformancePredicate({ payload: performancePredicate }) {
  try {
    const response = yield call(deletePerformancePredicateApi, performancePredicate);
    yield put(deletePerformancePredicateSuccess({ performancePredicate, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformancePredicateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformancePredicate({ payload: performancePredicate }) {
  try {
    const response = yield call(addNewPerformancePredicateApi, performancePredicate);
    yield put(addPerformancePredicateSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformancePredicateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformancePredicate() {
  yield takeEvery(GET_PERFORMANCEPREDICATE, getPerformancePredicate);
}

export function* watchUpdatePerformancePredicate() {
  yield takeEvery(UPDATE_PERFORMANCEPREDICATE, onUpdatePerformancePredicate);
}

export function* watchDeletePerformancePredicate() {
  yield takeEvery(DELETE_PERFORMANCEPREDICATE, onDeletePerformancePredicate);
}

export function* watchAddNewPerformancePredicate() {
  yield takeEvery(ADD_NEW_PERFORMANCEPREDICATE, onAddNewPerformancePredicate);
}

function* performancePredicateSaga() {
  yield all([
    fork(watchGetPerformancePredicate),
    fork(watchDeletePerformancePredicate),
    fork(watchUpdatePerformancePredicate),
    fork(watchAddNewPerformancePredicate)
  ]);
}

export default performancePredicateSaga;
